import makeStyles from '@mui/styles/makeStyles';

const contentStyles = makeStyles((theme) => ({
  root: {
    height: '100%',
    marginTop: 'clamp(0px, calc((1600px - 100vw) * 0.18), 57px)',
  },
  nav: {
    marginBottom: theme.spacing(1),
  },
  tabs: {
    backgroundColor: theme.palette.primary.dark,
    color: theme.palette.primary.light,
  },
  tabBMI: {
    backgroundColor: theme.palette.primary.dark,
  },
  tabIgualas: {
    backgroundColor: '#275075',
  },
}));

export default contentStyles;
